export const CERTIFICATION_INDUSTRIES = [
  "Cloud",
  "DevOps",
  "Data",
  "Data Engineering",
  "Data Science",
  "Artificial Intelligence",
  "Machine Learning",
  "Web Development",
  "Mobile Development",
  "Cybersecurity",
  "Software Engineering",
  "Backend",
  "Frontend",
  "Full Stack",
  "Databases",
  "Networking",
  "System Design",
  "Project Management",
  "Product Management",
  "UI/UX Design",
  "Blockchain",
  "Quality Assurance",
];

export const CUSTOM_INDUSTRY_VALUE = "__custom__";
